/**
 * What to tell somebody who has just come back from "connect Microsoft sign-in".
 *
 * The round trip returns with `?linked=<outcome>` because a redirect can carry nothing else, and it can now
 * land in two places -- Settings (Your account) and the Connect screen -- so the words live here, once. A
 * person who sees the same outcome in both must not read two different things.
 */
export function linkedOutcomeMessage(outcome: string): string {
  if (outcome === 'ok') return 'Microsoft sign-in is connected to this account.'

  if (outcome === 'owned_elsewhere') {
    return (
      'That Microsoft account is already connected to a different Defenssive account. ' +
      'Sign in to Microsoft as the account you want to use here, or disconnect it there first.'
    )
  }

  /*
   * NAMED, because "that did not complete" would send somebody looking for a Microsoft problem that is not
   * there. Connecting an account finishes only while the person who started it is still signed in HERE -- the
   * authority to attach an identity does not outlive the session that asked for it, which is what stops a
   * half-finished flow on a shared machine being finished by whoever sits down next.
   */
  if (outcome === 'signed_out') {
    return (
      'You were signed out before that finished, so nothing was connected. Sign in ' +
      'again and start it once more — connecting an account only completes while ' +
      'the person who started it is still signed in.'
    )
  }

  return 'That did not complete. Nothing was connected, and you can try again.'
}
